import { Navigate } from 'react-router-dom';

export default function AdminProtectedRoute({ children }) {

  const token = sessionStorage.getItem('adminToken');

  if (!token) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}